import { Col, Divider, Flex, Row, Space, Button, Card } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { Form, Formik } from "formik";
import { ReactComponent as CreateIcon } from "../../../assets/icon/createIcon.svg";

import { Input, InputNumber, Select, Switch } from "components/form";

import schema, {
  initialValues as INITIAL_VALUES,
} from "../schemas/companyBranchSchema";
import styles from "../styles/CompanyProfile.module.css";
import { useTranslation } from "react-i18next";
import { Footer } from "antd/es/layout/layout";

function CompanyBranchListEdit({
  isLoading = false,
  createMode = false,
  initialValues = {},
  provinceOptionsTh = [],
  provinceOptionsEn = [],
  districtOptionsTh = [],
  districtOptionsEn = [],
  subDistrictOptionsTh = [],
  subDistrictOptionsEn = [],
  onCancel = () => { },
  onSubmit = () => { },
  handleProviceChange = () => { },
  handleDistrictChange = () => { },
}) {
  const { t } = useTranslation();
  console.log("initialValues", initialValues);
  console.log("INITIAL_VALUES", INITIAL_VALUES);
  return (
    <Formik
      enableReinitialize
      initialValues={{ ...INITIAL_VALUES, ...initialValues }}
      onSubmit={onSubmit}
      validationSchema={schema}
    >
      {({ values = {}, setFieldValue, setTouched, errors }) => {
        console.log("errors", errors);
        const onProviceChange = (val) => {
          handleProviceChange(val);
          setFieldValue("districtId", null);
          setFieldValue("subDistrictId", null);
          setFieldValue("zipCode", null);
          setTouched(
            {
              districtId: false,
              subDistrictId: false,
              zipCode: false,
            },
            false
          );
        };

        const onDistrictChange = (val) => {
          handleDistrictChange(val);
          setFieldValue("subDistrictId", null);
          setFieldValue("zipCode", null);
          setTouched(
            {
              subDistrictId: false,
              zipCode: false,
            },
            false
          );
        };

        const onSubDistrictChange = (_, selectedValue) => {
          setFieldValue("zipCode", selectedValue.zipCode || null);
          setTouched({ zipCode: true }, false);
        };

        return (
          <Form>
            <Space className={styles.container} size={24} direction="vertical">
              {/* <Flex justify="end">
                <Space size={20}>
                  <Button onClick={onCancel}
                    style={{ width: "100px", height: "44px", borderRadius: "8px", padding: "8px 16px" }}>
                    {t("common.cancel").toUpperCase()}
                  </Button>
                  <Button htmlType="submit" style={{ width: "100px", height: "44px", borderRadius: "8px", backgroundColor: "#2CADE7", padding: "8px 16px", color: "white" }}>
                    {t("common.save").toUpperCase()}
                  </Button>
                </Space>
              </Flex> */}
              <Card style={{ border: "solid 1px #EAECF0" }}>
                <Row justify="space-between">
                  <b className={styles.infoTopic}>
                    {t("branch.label.branch_information")}
                  </b>
                </Row>
                <Divider />
                {isLoading ? (
                  <LoadingOutlined />
                ) : (
                  <>
                    <Row gutter={[24, 16]}>
                      <Col span={12}>
                        <Input
                          name="branchCode"
                          label={
                            t("branch.label.branch_id")
                          }
                          placeholder={t("branch.label.branch_id")}
                          size="large"
                          required
                        />
                      </Col>
                      <Col span={12}>
                      </Col>
                      <Col span={12}>
                        <Input
                          name="branchName"
                          label={
                            t("branch.label.name_th")
                          }
                          placeholder={t("branch.label.name_th")}
                          size="large"
                          required
                        />
                      </Col>
                      <Col span={12}>
                        <Input
                          name="branchNameEn"
                          label={
                            t("branch.label.name_en")
                          }
                          placeholder={t("branch.label.name_en")}
                          size="large"
                          required
                        />
                      </Col>
                    </Row>
                  </>
                )}
              </Card>
              <Card style={{ border: "solid 1px #EAECF0" }}>
                <Row justify="space-between">
                  <b className={styles.infoTopic}>
                    {t("branch.label.branch_address_information")}
                  </b>
                  <Switch name="branchAddressStatus" />
                </Row>
                <Divider />
                {isLoading ? <LoadingOutlined /> : <></>}
                {values.branchAddressStatus ? (
                  <>
                    {isLoading ? (
                      <LoadingOutlined />
                    ) : (
                      <>
                        <Row gutter={[24, 16]}>
                          <Col span={24}>
                            <Input
                              name="address"
                              label={
                                t("branch.label.address_th")
                              }
                              placeholder={
                                t("branch.label.address_th")
                              }
                              size="large"
                              required
                            />
                          </Col>
                          <Col span={6}>
                            <Select
                              name="provinceId"
                              label={
                                t("address.province")
                              }
                              placeholder={t('please-select-1')}
                              size="large"
                              options={provinceOptionsTh}
                              onChange={(_, item) => {
                                onProviceChange(item?.provinceCode)
                              }}
                              required
                            />
                          </Col>
                          <Col span={6}>
                            <Select
                              name="districtId"
                              label={
                                t("address.district")
                              }
                              placeholder={t('please-select-1')}
                              size="large"
                              options={districtOptionsTh}
                              onChange={(_, item) => {
                                onDistrictChange(item?.districtCodeId)
                              }}
                              required
                            />
                          </Col>
                          <Col span={6}>
                            <Select
                              name="subDistrictId"
                              label={
                                t("address.subdistrict")
                              }
                              placeholder={t('please-select-1')}
                              size="large"
                              options={subDistrictOptionsTh}
                              onChange={onSubDistrictChange}
                              required
                            />
                          </Col>
                          <Col span={6}>
                            <Input
                              name="zipCode"
                              label={
                                t("address.postal_code")
                              }
                              placeholder={t('address.postal_code')}
                              size="large"
                              maxLength={5}
                              required
                            />
                          </Col>
                          <Col span={24}>
                            <Input
                              name="addressEn"
                              label={
                                t("branch.label.address_en")
                              }
                              placeholder={t('branch.label.address_en')}
                              size="large"
                              required
                            />
                          </Col>
                          <Col span={6}>
                            <Select
                              name="provinceId"
                              label={
                                t("address.province")
                              }
                              placeholder={t('please-select-1')}
                              size="large"
                              options={provinceOptionsEn}
                              onChange={(_, item) => {
                                onProviceChange(item?.provinceCode)
                              }}
                              required
                            />
                          </Col>
                          <Col span={6}>
                            <Select
                              name="districtId"
                              label={
                                t("address.district")
                              }
                              placeholder={t('please-select-1')}
                              size="large"
                              options={districtOptionsEn}
                              onChange={(_, item) => {
                                onDistrictChange(item?.districtCodeId)
                              }}
                              required
                            />
                          </Col>
                          <Col span={6}>
                            <Select
                              name="subDistrictId"
                              label={
                                t("address.subdistrict")
                              }
                              placeholder={t('please-select-1')}
                              size="large"
                              options={subDistrictOptionsEn}
                              onChange={onSubDistrictChange}
                              required
                            />
                          </Col>
                          <Col span={6}>
                            <Input
                              name="zipCode"
                              label={
                                t("address.postal_code")
                              }
                              placeholder={
                                t("address.postal_code")
                              }
                              size="large"
                              maxLength={5}
                              required
                            />
                          </Col>
                        </Row>
                      </>
                    )}
                  </>
                ) : (
                  <></>
                )}
              </Card>
              <Card style={{ border: "solid 1px #EAECF0" }}>
                <Row justify="space-between">
                  <b className={styles.infoTopic}>
                    {t("branch.label.compensation_rate")}
                  </b>
                  <Switch name="branchCompensateStatus" />
                </Row>
                <Divider />
                {isLoading ? <LoadingOutlined /> : <></>}
                {values.branchCompensateStatus ? (
                  <>
                    {isLoading ? (
                      <LoadingOutlined />
                    ) : (
                      <>
                        <Row gutter={[24, 16]}>
                          <Col span={12}>
                            <Input
                              name="bankAccountNo"
                              label={t("branch.label.bank_account_no")}
                              placeholder={t("branch.label.bank_account_no")}
                              size="large"
                            />
                          </Col>
                          <Col span={12}>
                            <Input
                              name="businessCode"
                              label={t("branch.label.business_code")}
                              placeholder={t("branch.label.business_code")}
                              size="large"
                            />
                          </Col>
                          <Col span={12}>
                            <InputNumber
                              suffix="%"
                              name="insurancePersonRate"
                              label={t("branch.label.insurance_contribution")}
                              placeholder={t("branch.label.insurance_contribution")}
                              size="large"
                              min={0}
                            />
                          </Col>
                          <Col span={12}>
                            <InputNumber
                              prefix="฿"
                              name="salaryNotOver"
                              label={t("branch.label.salary_not_over")}
                              placeholder={t("branch.label.salary_not_over")}
                              size="large"
                              min={0}
                            />
                          </Col>
                        </Row>
                      </>
                    )}
                  </>
                ) : (
                  <></>
                )}
              </Card>
            </Space>
            <Footer style={{
              zIndex: 999,
              bottom: 1,
              position: 'sticky',
              backgroundColor: 'white',
              height: "fit-content",
              padding: '10px 50px',
            }}>
              <Row justify="end" style={{ gap: "12px" }}>
                <Button type="default" onClick={() => {
                  onCancel()
                }} style={{ height: "40px", borderRadius: "8px", padding: "8px 16px" }}
                >
                  {t("common.cancel").toUpperCase()}
                </Button>
                <Button type="primary" htmlType="submit" style={{ height: "40px", borderRadius: "8px", backgroundColor: "var(--button-color)", color: "white" }}>
                  {t("common.submit").toUpperCase()}
                </Button>
              </Row>
            </Footer>
          </Form>
        );
      }}
    </Formik>
  );
}

export default CompanyBranchListEdit;
